import memoWithDisplayName from '../../../utils/memoWithDisplayName';
import { Text } from 'breadcrumbs-ui/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MenuPickerBody = memoWithDisplayName('MenuPickerBody', ({
  name,
  portalId
}) => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      color: "text-core-default",
      typography: "heading-50",
      whiteSpace: "pre-wrap",
      textDecoration: "none",
      marginBlockStart: "100",
      children: name
    }), portalId ? /*#__PURE__*/_jsx(Text, {
      color: "text-core-default",
      typography: "body-100",
      textDecoration: "none",
      marginBlockStart: "100",
      children: portalId
    }) : null]
  });
});